import React from 'react';
import cn from 'classnames';

import styles from './style.scss';

interface IProps {
  children?: React.ReactNode;
  className?: string;
}

const EmptyView = ({ children, className }: IProps) => (
  <div className={cn(className, styles['empty-view'])} data-test="empty-view">
    {children}
  </div>
);

export default EmptyView;
